import React, { forwardRef, ForwardedRef } from 'react';
import { ListItemIcon, MenuItem, TextFieldProps } from '@mui/material';

import Default from './TextFieldDefault';

type Option = {
  id: string | number;
  label: string;
  icon?: JSX.Element;
};

type SelectProps = TextFieldProps & {
  ranges: Option[];
};

const Select = forwardRef((props: SelectProps, ref: ForwardedRef<SelectProps>) => {
  const { ranges } = props;

  return (
    <Default
      ref={ref}
      select
      {...props}
      inputProps={{
        sx: {
          display: 'flex',
          alignItems: 'center',
          '& .MuiListItemIcon-root': {
            minWidth: 40,
          },
        },
      }}
    >
      {ranges.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
          {option.label}
        </MenuItem>
      ))}
    </Default>
  );
});

Select.displayName = 'Select';

export default Select;
